import {Component, OnInit} from '@angular/core';
import {
  QuarantinePlacementFormComponent
} from "@app/quarantine/quarantine-placement-form/quarantine-placement-form.component";
import {QuarantinePlacementFormInterface} from "@app/quarantine/intrfaces/quarantine.interface";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonModule} from "@angular/common";
import {DataService} from "@app/shared/data.service";

@Component({
  selector: 'app-edit-quarantine-placement',
  templateUrl: './edit-quarantine-placement.component.html',
  styleUrls: ['./edit-quarantine-placement.component.scss'],
  standalone: true,
  imports: [
    QuarantinePlacementFormComponent,
    CommonModule
  ]
})
export class EditQuarantinePlacementComponent implements OnInit {
  
  constructor(
      private activatedRoute: ActivatedRoute,
      private dataService: DataService
  ) {
  }
  
  ngOnInit() {
    let breadcrumbs =  [...this.activatedRoute.snapshot.data['breadcrumbs']]
    let documentPlacement = history.state.quarantinePlacement
    
    let text = documentPlacement?.documentStatus === 'DRAFT' ?
        `Керувати розміщенням у карантин №${history.state.quarantinePlacement?.id}` :
        `Розміщення у карантин №${history.state.quarantinePlacement?.id}`
    
    breadcrumbs.push({title: text, link: ''});
    this.dataService.breadcrumbsArray.next(breadcrumbs)
  }
  
  config: QuarantinePlacementFormInterface = {
    documentType: 'QUARANTINE_PLACEMENT',
    stage: "EDIT"
  }
  
}
